var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSliderPrev = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 46,
  height: 47,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#102A56",
  strokeWidth: 2,
  d: "M22.75 45.205c12.012 0 21.75-9.738 21.75-21.75s-9.738-21.75-21.75-21.75S1 11.443 1 23.455s9.738 21.75 21.75 21.75Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#102A56",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m26.727 14.684-8.693 8.693 8.693 8.693"
})));
export default SvgSliderPrev;